import { getPubAbbr } from "@revbox/helpers-fe";
import { TaxonomyModule } from "../../../../../modules/taxonomy";
import { formatThousand } from "@revbox/helpers-fe";

export function MissedClicksForecastRenderer({ value }) {
    if (!value) {
        return null;
    }

    const est_clicks = Number(value.split("@")[0]);
    const est_click_opportunity = Number(value.split("@")[2]);

    const status = value.split("@")[7];
    const position = Number(value.split("@")[8]);

    const noViews = value.split('@')[17] === 'true'

    const percentage = ((est_click_opportunity+est_clicks)/est_clicks - 1) * 100;
    const clicks = est_click_opportunity === 1 ? 'click' : 'clicks';

    // Handle unavailable clusters (0 views) first - they should always show X
    if (noViews) {
        return (
            <div className="d-flex align-items-center click-opportunity-column">
                <div style={{width: '100%', opacity: 0.5}}>
                    <i class="ri-close-line"></i>
                </div>
            </div>
        );
    }

    if (position == 1 && status?.toUpperCase() !== "INACTIVE") {
        return (
            <div className="d-flex align-items-center click-opportunity-column">
                <span style={{width: '100%'}}>
                    <small>Max</small>
                </span>
            </div>
        );
    }

    if (status?.toUpperCase() === "INACTIVE") {
        if (est_click_opportunity <= 0) {
            return (
                <div className="d-flex align-items-center click-opportunity-column">
                    <div style={{width: '100%'}}>
                        <small>Max</small>
                    </div>
                </div>
            );
        }
    }

    if (status?.toUpperCase() === "DRAFT" || status?.toUpperCase() === "PENDING" || status?.toUpperCase() === "PAUSED") {
        if (est_click_opportunity <= 0) {
            return (
                <div className="d-flex align-items-center click-opportunity-column">
                    <div style={{width: '100%', opacity: 0.5}}>
                        <i class="ri-close-line"></i>
                    </div>
                </div>
            );
        }
    }

    if (est_click_opportunity === 0) {
        return (
            <div className="d-flex align-items-center click-opportunity-column">
                <div style={{width: '100%'}}>
                    <small>Max</small>
                </div>
            </div>
        );
    }

    if (est_clicks > 0) {
        return (
            <div className="d-flex align-items-center click-opportunity-column">
                <div style={{width: '100%'}}>
                    <small>+{formatThousand(est_click_opportunity)} {clicks}<span class="d-inline-flex text-warning ms-1">{formatThousand(Math.round(percentage)) + '%'}<i class="ri-arrow-up-line"></i></span></small>
                </div>
            </div>
        );
    }

    return (
        <div className="d-flex align-items-center click-opportunity-column">
            <div style={{width: '100%'}}>
                <small>+{formatThousand(est_click_opportunity)} {clicks}<span class="d-inline-flex text-warning ms-1">∞<i class="ri-arrow-up-line"></i></span></small>
            </div>
        </div>
    );
}
 
export function MissedClicksForecastCellColumnHeaderTooltipRenderer() {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    return taxonomy.tooltips.ppc_cluster_column_headers.missed_clicks_forecast;
}

export function MissedClicksForecastCellTooltipRenderer({ value }) {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);

    if (!value) {
        return null;
    }

    const est_clicks = Number(value.split("@")[0]);
    const est_click_opportunity = Number(value.split("@")[2]);
    const status = value.split("@")[7];
    const position = Number(value.split("@")[8]);
    const noViews = value.split('@')[17] === 'true'

    // Unavailable clusters (no views) - check first before position
    if (noViews) {
        return taxonomy.tooltips.ppc_cluster_column_inlines.missed_clicks_forecast.directory_cluster_with_no_campaign_relation_via_categories;
    }

    // Position #1 - optimized
    if (position == 1) {
        if (est_clicks > 0) {
            return taxonomy.tooltips.ppc_cluster_column_inlines.missed_clicks_forecast.no_opportunity.replace("{clicks}", est_clicks);
        } else {
            return taxonomy.tooltips.ppc_cluster_column_inlines.missed_clicks_forecast.no_opportunity.replace("{clicks}", "0");
        }
    }

    // Inactive status with no opportunity
    if (status?.toUpperCase() === "INACTIVE") {
        if (est_click_opportunity <= 0) {
            return taxonomy.tooltips.ppc_cluster_column_inlines.missed_clicks_forecast.no_opportunity.replace("{clicks}", est_clicks);
        }
    }

    // Draft, Pending, or Paused status with no opportunity
    if (status?.toUpperCase() === "DRAFT" || status?.toUpperCase() === "PENDING" || status?.toUpperCase() === "PAUSED") {
        if (est_click_opportunity <= 0) {
            return taxonomy.tooltips.ppc_cluster_column_inlines.missed_clicks_forecast.no_opportunity.replace("{clicks}", est_clicks);
        }
    }
    
    // Has click opportunity
    if (est_click_opportunity > 0) {
        return taxonomy.tooltips.ppc_cluster_column_inlines.missed_clicks_forecast.click_opportunity_more_than_0.replace("{clicks}", est_click_opportunity);
    } 

    // Default case - no opportunity
    if (est_click_opportunity <= 0) {
        return taxonomy.tooltips.ppc_cluster_column_inlines.missed_clicks_forecast.no_opportunity.replace("{clicks}", est_clicks);
    }

    return taxonomy.tooltips.ppc_cluster_column_inlines.missed_clicks_forecast.no_opportunity.replace("{clicks}", est_clicks);
}